module.exports = __webpack_public_path__ + "img/security-root.9d9604a.svg";